import { number, object } from 'zod';

import { VoucheredOfferSchema, VoucherExpirationDaysSchema } from './award-vouchers.schema';

import { withIsEnabled } from '../utils/with-is-enabled';

const AwardVouchersConstraintEnabledSchema = object({
  voucheredOffer: VoucheredOfferSchema,
  voucherExpirationDays: VoucherExpirationDaysSchema,
});

const AwardVouchersConstraintDisabledSchema = object({
  voucheredOffer: VoucheredOfferSchema.partial(),
  voucherExpirationDays: number().optional(),
});

export const AwardVouchersConstraintSchema = withIsEnabled(
  AwardVouchersConstraintEnabledSchema,
  AwardVouchersConstraintDisabledSchema,
);
